import React from 'react'
import { Line } from 'rc-progress'
import Item from './item'
import iconAverage from '../../../../../../images/iconAverages.png'
import iconCalendar from '../../../../../../images/iconCalendar.png'

const MacroData = (props) => {
  const macroData = props.macroData
  const trackerData = props.trackerData
  const relatedWeighInDateString = props.relatedWeighInDateString

  const getFiber = (carb) => {
    if(carb <= 75) return 10;
    else if(carb > 75 && carb <= 125) return 15;
    else if(carb > 125 && carb <= 175) return 20;
    else if(carb > 175 && carb <= 250) return 25;
    else if(carb > 250) return 30;
  }

  const renderLineGraphs = () => {
    let consumedProtein = 0
    let consumedCarbs = 0
    let consumedFat = 0
    let consumedFiber = 0
    let targetProtein = 0
    let targetCarbs = 0
    let targetFat = 0
    let avgProtein = props.macroData.avgProtein;
    let avgCarbs = props.macroData.avgCarbs;
    let avgFat = props.macroData.avgFat;
    let avgTargetProtein = props.macroData.avgTargetProtein;
    let avgTargetCarbs = props.macroData.avgTargetCarbs;
    let avgTargetFat = props.macroData.avgTargetFat;

    let avgConsumedCalories = (Math.round(avgProtein) + Math.round(avgCarbs)) * 4 + Math.round(avgFat) * 9
    let avgTargetCalories = 4 * (avgTargetProtein + avgTargetCarbs) + 9 * avgTargetFat;
    let avgRemainingCalories = avgTargetCalories - avgConsumedCalories

    let avgConsumedFiber = props.macroData.avgFiber;
    let avgTargetFiber = getFiber(avgTargetCarbs);
    let avgRemainingFiber = avgTargetFiber - avgConsumedFiber

    const relatedWeighInDetails = macroData.weighInDetails[relatedWeighInDateString]
    let key = trackerData.selectedTrackerDate
    if(key in relatedWeighInDetails.result.stage_5) {
      targetProtein = Math.round(relatedWeighInDetails.result.stage_5[key].protein)
      targetCarbs = Math.round(relatedWeighInDetails.result.stage_5[key].carbs)
      targetFat = Math.round(relatedWeighInDetails.result.stage_5[key].fat)
    } else {
      key = null
      for(let candidate_key in relatedWeighInDetails.result.stage_5) {
        if(key === null || candidate_key > key) {
          key = candidate_key
        }
      }
      targetProtein = Math.round(relatedWeighInDetails.result.stage_1[key].protein)
      targetCarbs = Math.round(relatedWeighInDetails.result.stage_1[key].carbs)
      targetFat = Math.round(relatedWeighInDetails.result.stage_1[key].fat)
    }

    let targetCalories = 4 * (targetCarbs + targetProtein) + (9 * targetFat)

    let targetFiber = Math.round(getFiber(targetCarbs))

    let items = trackerData.timeline[trackerData.selectedTrackerDate]

    if (items) {
      items.forEach(item => {
        item = new Item(item);
        if(item.itemType === 'recipe') {
          consumedProtein += item.getRecipeProtein()
          consumedCarbs += item.getRecipeCarbs()
          consumedFat += item.getRecipeFat()
          consumedFiber += item.getRecipeFiber()
        }
        else {
          consumedProtein += item.getProtein()
          consumedCarbs += item.getCarbs()
          consumedFat += item.getFat()
          consumedFiber += item.getFiber()
        }    
      });
    }

    let consumedCalories = 4 * (consumedCarbs + consumedProtein) + (9 * consumedFat)
    let remainingCalories = Math.round(targetCalories - consumedCalories);
    let remainingFiber = Math.round(targetFiber - consumedFiber);
    let percentCalories = ((consumedCalories / targetCalories) * 100).toFixed(2);
    let percentFiber = ((consumedFiber / targetFiber) * 100).toFixed(2);

    let displayTextCalories
    let displayTextFiber

    if (props.showWeeklyAvg) {
      percentCalories = ((avgConsumedCalories / avgTargetCalories) * 100).toFixed(2)
      percentFiber = ((avgConsumedFiber / avgTargetFiber) * 100).toFixed(2);

      if(avgTargetCalories === 0) {
        percentCalories = 0
        percentFiber = 0
      }
      if (trackerData.showConsumedMacros | props.vacationMode === 2) {
        // Average Consumed
        displayTextCalories = `${Math.round(avgConsumedCalories)} Eaten`
        displayTextFiber = `${Math.round(avgConsumedFiber)} Eaten`
      } else {
        // Average Remaining
        displayTextCalories = `${Math.round(avgRemainingCalories)} Left`
        displayTextFiber = `${Math.round(avgRemainingFiber)} Left`
      }
    } else {
      if (trackerData.showConsumedMacros || props.vacationMode === 2) {
        // Consumed
        displayTextCalories = `${Math.round(consumedCalories)} Eaten`
        displayTextFiber = `${Math.round(consumedFiber)} Eaten`
      } else {
        // Remaining
        displayTextCalories = `${Math.round(remainingCalories)} Left`
        displayTextFiber = `${Math.round(remainingFiber)} Left`
      }
    }

    return (
      <div className="tracker-data-container">
        <div className="tracker-data-macros-container">
          <div className="tracker-data-text">
            <label>{props.showWeeklyAvg ? 'AVG. CALORIES' : 'CALORIES'}</label>
            <Line
              percent={percentCalories}
              strokeWidth="9"
              strokeLinecap="round"
              strokeColor="#31bfff"
              trailWidth="9"
              trailColor="#1d2345"
            />
            <label style={{color: '#FFF'}}>{displayTextCalories}</label>
          </div>
          {!props.inspectOverview &&
            <button className="tracker-data-toggle" onClick={() => props.updateShowWeeklyAvg(!props.showWeeklyAvg)}>
              <img src={props.showWeeklyAvg ? iconCalendar : iconAverage} alt="icon" />
              <p className={props.showWeeklyAvg ? "show-average active" : "show-average"}>{props.showWeeklyAvg ? "Show today" : "Show averages"}</p>
            </button>
          }
          <div className="tracker-data-text">
            <label>{props.showWeeklyAvg ? 'AVG. FIBER' : 'FIBER'}</label>
            <Line
              percent={percentFiber}
              strokeWidth="9"
              strokeLinecap="round"
              strokeColor="#31bfff"
              trailWidth="9"
              trailColor="#1d2345"
            />
            <label style={{color: '#FFF'}}>{displayTextFiber}</label>
          </div>
          {/* {(user.fasting === 1) &&
            <div className="tracker-fasting-container">
              {this.renderTimeProgress()}
            </div>
          } */}
        </div>
      </div>
    );
  }

  return <div>{renderLineGraphs()}</div>
}

export default MacroData

